import { render, staticRenderFns } from "./CreateLiveClasses.vue?vue&type=template&id=1d7a20da"
import script from "./CreateLiveClasses.vue?vue&type=script&lang=js"
export * from "./CreateLiveClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports